<template>
    <section v-if="active" class="py-8">
        <slot>
            <p>Nenhum conteúdo por enquanto...</p>
        </slot>
    </section>
</template>

<script>
    export default {
        name: "Tab",
        props: {
            title: {require: true},
            selected: {default: false}
        },
        data() {
            return {
                active: false
            }
        },
        mounted() {
            this.active = this.selected;
        }
    }
</script>

<style scoped>

</style>